/** Unique history transaction id for one panel commit: `<prefix>:<timestamp>:<random>`. */
export function createHistoryTxnId(prefix: string): string {
  return `${prefix}:${Date.now()}:${Math.random().toString(36).slice(2, 8)}`
}
